import React, { useState, useRef } from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Productos from './componentes/productosFactura';
import ClienteFactura from './componentes/clienteFactura';
import AlertsFacturas from './Utils/AlertsFacturas';
import APIserver from '../../../api/axiosConfig';
import Swal from 'sweetalert2';
import CrearPagoResModal from '../PagosResibidos/componentes/crearPagoResModal';

function CrearFactura() {
  const [idCliente, setIdCliente] = useState('');
  const [currentDate, setCurrentDate] = useState('');
  const [venceDate, setVenceDate] = useState('');
  const [productos, setProductos] = useState([]);
  const [formaPago, setformaPago] = useState(() => {
    try {
      return localStorage.getItem('forma_pago_preferida_fac') || 'efectivo';
    } catch (e) {
      return 'efectivo';
    }
  });
  const [transport, settransportadora] = useState(() => {
    try {
      return localStorage.getItem('transportadora_preferida_fac') || '';
    } catch (e) {
      return '';
    }
  });
  const [dondePago, setDondePago] = useState('');
  const [numGuia, setnumGuia] = useState('');
  const [envio, setEnvio] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [cantItem, setCantItem] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [tipoFactura, setTipoFactura] = useState('unidad');

  const [showPagoModal, setShowPagoModal] = useState(false);
  const [facturaCreada, setFacturaCreada] = useState(null);
  const paymentSavedRef = useRef(false);

  const navigate = useNavigate();

  const handleformaPagoChange = (e) => {
    setformaPago(e.target.value);
  };
  const handleTipoFacturaChange = (e) => {
    setTipoFactura(e.target.value);
  };

  const preguntarVolverFacturas = () => {
    Swal.fire({
      icon: 'question',
      title: 'Factura creada',
      text: '¿Deseas crear otra factura?',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      iconColor: '#f4bd61',
      confirmButtonColor: '#2c4cc4',
      cancelButtonColor: '#da292e'
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload(); // Se queda en crear facturas (recarga el formulario limpio)
      } else {
        navigate('/admin/IngresosFacturas/'); // Redirige a ver facturas
      }
    });
  };

  const handleClosePagoModal = (isSaved) => {
    setShowPagoModal(false);
    if (isSaved === true) {
      paymentSavedRef.current = true;
    } else if (!paymentSavedRef.current) {
      preguntarVolverFacturas();
    }
  };

  const handlePagoSuccess = () => {
    paymentSavedRef.current = true;
    setShowPagoModal(false);
    preguntarVolverFacturas();
  };

  const validateFacturaData = () => {

    // Verifica que haya productos válidos (con referencia y cantidad > 0)
    const productosValidos = productos.filter(
      (producto) => producto.referencia && producto.cantidad > 0
    );

    if (!idCliente || !currentDate || !venceDate || !formaPago || !tipoFactura || productosValidos.length === 0) {
      AlertsFacturas.showErrorMessage('Por favor complete todos los campos obligatorios, incluyendo al menos un producto válido.');
      return false;
    }
    return true;
  };

  const handleCreateFactura = async () => {
    if (!validateFacturaData()) return;

    const facturaData = {
      idCliente: idCliente,
      creacion: currentDate,
      vence: venceDate,
      totalFacV: total,
      subtotal,
      cantItem,
      cosEnvio: envio,
      formaPago,
      transport,
      dondePago,
      numGuia,
      descuento,
      tipoFactura,
      productos: productos.map(producto => ({
        ...producto,
        valorUnitario: parseFloat(producto.valorUnitario) // Asegúrate de que el valor sea un número
      })) // Aquí se incluye el objeto productos que contiene el valor unitario modificado
    };

    //console.log('Datos de la factura a enviar:', facturaData); // Agregar log para depuración

    try {
      // Validar los datos antes de continuar
      if (!validateFacturaData()) return;

      // Mostrar alerta de carga
      const loadingAlert = Swal.fire({
        title: 'Creando factura...',
        text: 'Por favor, espere un momento.',
        allowOutsideClick: false, // Deshabilitar hacer clic fuera de la alerta
        didOpen: () => {
          Swal.showLoading(); // Mostrar animación de carga
        }
      });

      // Enviar la solicitud al servidor
      const response = await APIserver.post(`/api/facturas`, facturaData);

      // Cerrar alerta de carga
      Swal.close();

      let numFacV = response.data?.numFacV || response.data?.numeroFactura;
      let idFacV = response.data?.idFacV || response.data?.idFactura;

      // Fallback si por alguna razón no viniera directamente en la respuesta
      if (!numFacV) {
        try {
          const ultFacturaRes = await APIserver.get('/api/Mostrar/facturas?rowsPerPage=1&page=1&sortField=numFacV&sortOrder=DESC');
          if (ultFacturaRes.data?.facturas?.length > 0) {
            const ultima = ultFacturaRes.data.facturas[0];
            numFacV = ultima.numeroFactura || ultima.numFacV;
            idFacV = ultima.idFactura || ultima.idFacV;
          }
        } catch (e) {
          console.warn('No se pudo obtener el último número de factura:', e);
        }
      }

      const infoFactura = {
        numeroFactura: numFacV || '',
        numFacV: numFacV || '',
        idFacV: idFacV,
        idFactura: idFacV
      };
      setFacturaCreada(infoFactura);
      paymentSavedRef.current = false;

      // Alerta de éxito de creación
      await Swal.fire({
        icon: 'success',
        iconColor: '#2fb380',
        title: '¡Éxito!',
        text: numFacV ? `Factura ${numFacV} creada con éxito.` : 'Factura creada con éxito',
        showConfirmButton: false,
        timer: 1800
      });

      // Abrir directamente el modal de pago
      setShowPagoModal(true);
    } catch (error) {
      // Cerrar alerta de carga si hay un error
      Swal.close();
      console.error('Error al crear la factura:', error);
      AlertsFacturas.showErrorMessage('Error al crear la factura');
    }
  };

  const handleCancel = () => {
    if (
      idCliente ||
      currentDate ||
      venceDate ||
      productos.length > 0 ||
      tipoFactura ||
      formaPago ||
      transport ||
      dondePago ||
      numGuia ||
      envio ||
      subtotal ||
      total ||
      cantItem
    ) {
      AlertsFacturas.showCancelConfirmation(() => {
        navigate('/admin/IngresosFacturas/');
      });
    } else {
      navigate('/admin/IngresosFacturas/');
    }
  };

  return (
    <div className='mx-2 mt-3 mt-md-0'>
      <div className='m-2 text-center'>
        <Button variant='dark' className='me-2' onClick={handleCancel}>Cancelar</Button>
        <Button variant='danger' className='me-2' onClick={handleCreateFactura}>Crear Factura</Button>
      </div>
      <Card className='shadow-none'>
        <Card.Header className='fw-bold'>
          Detalles de cliente
        </Card.Header>
        <Card.Body>
          <ClienteFactura
            setClienteID={setIdCliente}
            setVenceDate={setVenceDate}
            setformaPago={setformaPago}
            settransportadora={settransportadora}
            setCreacionDate={setCurrentDate}
            setdondePago={setDondePago}
            setnumGuia={setnumGuia}
            setTipoFactura={setTipoFactura}
          />
        </Card.Body>
      </Card>
      <Productos
        setProductos={setProductos}
        setSubtotal={setSubtotal}
        setTotal={setTotal}
        setCantItem={setCantItem}
        setEnvio={setEnvio}
        setDescuento={setDescuento}
        tipoFactura={tipoFactura}
      />
      <div className='m-2 text-center'>
        <Button variant='dark' className='me-2' onClick={handleCancel}>Cancelar</Button>
        <Button variant='danger' className='me-2' onClick={handleCreateFactura}>Crear Factura</Button>
      </div>

      {/* Modal para agregar pago a la factura recién creada */}
      {showPagoModal && facturaCreada && (
        <CrearPagoResModal
          show={showPagoModal}
          handleClose={handleClosePagoModal}
          factura={facturaCreada}
          onSuccess={handlePagoSuccess}
        />
      )}
    </div>
  );
}

export default CrearFactura;